import type React from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactCountryIcons, SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { StyledSelectionBox, IconWrapper, IconKeywordsWrapper, TitleOverflow, LabelOverflow } from "./StyledComponents";
import type { ISelectionBoxProps } from "./types";

export const SelectionBox: React.FC<ISelectionBoxProps> = ({ text, icon, secondaryText, isCountry }) => {
    return (
        <StyledSelectionBox>
            {isCountry ? (
                <IconWrapper>
                    <SWReactCountryIcons
                        // @ts-expect-error - string is not assignable to type number
                        countryCode={icon}
                        iconSize="xs"
                        iconColor={colorsPalettes.carbon[25]}
                        className="subtitle-country"
                    />
                </IconWrapper>
            ) : (
                <IconKeywordsWrapper>
                    <SWReactIcons
                        iconName={icon as IconName}
                        size={"xs"}
                        iconColor={colorsPalettes.carbon[400]}
                    />
                </IconKeywordsWrapper>
            )}
            <div>
                <TitleOverflow>{text}</TitleOverflow>
                <LabelOverflow>{secondaryText}</LabelOverflow>
            </div>
        </StyledSelectionBox>
    );
};
